// import axios from "axios";
// import router from "../router";

export default function auth2({ next }) {

    return next();


}
